/* ============================================
 * Liene Pearl LP - All-in-One JS
 * Performance: Single deferred file, browser-cached
 * Includes: reveal animations, video lazy load,
 *           video player, FAQ accordion, countdown timer
 * ============================================ */

(function(){
  'use strict';

  // ==========================================
  // 1. Reveal animations (IntersectionObserver)
  // ==========================================
  if('IntersectionObserver' in window){
    var revealIO = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('lp-show');
          revealIO.unobserve(entry.target);
        }
      });
    },{threshold:0.1,rootMargin:'0px 0px -10% 0px'});

    document.querySelectorAll('.lp-reveal').forEach(function(el){
      revealIO.observe(el);
    });
  } else {
    document.querySelectorAll('.lp-reveal').forEach(function(el){
      el.classList.add('lp-show');
    });
  }

  // ==========================================
  // 2. Lazy load videos
  // ==========================================
  if('IntersectionObserver' in window){
    var videoIO = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var video = entry.target;
          var sources = video.querySelectorAll('source[data-src]');
          sources.forEach(function(source){
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          if(sources.length > 0){
            video.load();
          }
          if(video.dataset.poster){
            video.poster = video.dataset.poster;
          }
          videoIO.unobserve(video);
        }
      });
    },{rootMargin:'200px'});

    document.querySelectorAll('video.lp-lazy-video').forEach(function(v){
      videoIO.observe(v);
    });
  }

  // ==========================================
  // 3. Lazy iframes (e.g., YouTube embeds)
  // ==========================================
  if('IntersectionObserver' in window){
    var iframeIO = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var iframe = entry.target;
          if(iframe.dataset.src){
            iframe.src = iframe.dataset.src;
            iframe.removeAttribute('data-src');
          }
          iframeIO.unobserve(iframe);
        }
      });
    },{rootMargin:'200px'});

    document.querySelectorAll('iframe[data-src]').forEach(function(f){
      iframeIO.observe(f);
    });
  }

  // ==========================================
  // 4. Video player control (global function)
  // ==========================================
  window.lpPlayVideo = function(frame){
    var video = frame.querySelector('video');
    var poster = frame.querySelector('.video-poster');
    var playBtn = frame.querySelector('.video-play-btn');
    var meta = frame.querySelector('.video-meta');

    if(!video) return;

    var hasSource = video.querySelector('source[src]') || video.querySelector('source[data-src]');

    if(!hasSource){
      lpShowVideoNotice(frame);
      return;
    }

    if(video.paused){
      poster && poster.classList.add('hidden');
      playBtn && (playBtn.style.display = 'none');
      meta && (meta.style.opacity = '0');
      video.play();
    } else {
      video.pause();
      poster && poster.classList.remove('hidden');
      playBtn && (playBtn.style.display = 'flex');
      meta && (meta.style.opacity = '1');
    }
  };

  function lpShowVideoNotice(frame){
    if(frame.querySelector('.video-demo-notice')) return;
    var notice = document.createElement('div');
    notice.className = 'video-demo-notice';
    notice.innerHTML = '<div class="vdn-title">▶ DEMO PREVIEW</div><div class="vdn-text">実際の動作動画は、公開時にこちらでご覧いただけます。</div>';
    frame.appendChild(notice);
    setTimeout(function(){
      if(notice.parentNode) notice.remove();
    }, 4000);
    notice.addEventListener('click', function(e){
      e.stopPropagation();
      notice.remove();
    });
  }

  // ==========================================
  // 5. FAQ accordion (event delegation)
  // ==========================================
  document.addEventListener('click', function(e){
    var q = e.target.closest('.liene-faq-q');
    if(!q) return;
    var item = q.parentElement;
    var expanded = item.classList.toggle('open');
    q.setAttribute('aria-expanded', expanded);
  });

  // ==========================================
  // 6. Smooth scroll for anchor links
  // ==========================================
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if(!a) return;
    var href = a.getAttribute('href');
    if(href === '#' || href.length < 2) return;
    var target = document.querySelector(href);
    if(target){
      e.preventDefault();
      target.scrollIntoView({behavior:'smooth',block:'start'});
    }
  });

  // ==========================================
  // 7. Countdown timer (auto-detect)
  // ==========================================
  document.querySelectorAll('[data-liene-timer]').forEach(function(timer){
    var sec = parseInt(timer.dataset.lieneTimer || 0, 10);
    if(sec <= 0) return;
    var d = timer.querySelector('[data-d]');
    var h = timer.querySelector('[data-h]');
    var m = timer.querySelector('[data-m]');
    var s = timer.querySelector('[data-s]');

    function update(){
      if(sec <= 0) return;
      sec--;
      var dd = Math.floor(sec/86400);
      var hh = Math.floor((sec%86400)/3600);
      var mm = Math.floor((sec%3600)/60);
      var ss = sec%60;
      d && (d.textContent = String(dd).padStart(2,'0'));
      h && (h.textContent = String(hh).padStart(2,'0'));
      m && (m.textContent = String(mm).padStart(2,'0'));
      s && (s.textContent = String(ss).padStart(2,'0'));
    }
    setInterval(update, 1000);
  });

})();
